import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class JobOfferPageContent extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get bannerImage() {
    return get(this, '_banner_image.value[0].url', '');
  }

  get bannerImageJobOffer() {
    return get(this, '_banner_image___oferta_pracy.value[0].url', '');
  }

  get benefits() {
    return get(this, '_benefity.value', []).map(item => ({
      image: get(item, 'ikona.value[0].url', ''),
      text: get(item, 'tekst.value', '')
    }));
  }

  get benefitsTitle() {
    return get(this, '_benefity___tytul.value', '');
  }

  get benefitsIntro() {
    return get(this, '_benefity___intro.value', '');
  }

  get rodoClause() {
    return get(this, '_cv___klauzula_rodo.value', '');
  }

  get cvButtonURL() {
    return get(this, '_cv___adres_url_do_guzika.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/JobOfferPageContent.js